// extracted by mini-css-extract-plugin
export var fullGrid = "_2u-3";
export var pdpPreviewContainer = "_2u-1";
export var previewContainer = "_2u-0";
export var togglePreviewContainer = "_2u-2";